import {SearchFilterPredefined} from '../models/SearchFilterPredefined';
import {archiveFileTypeResource} from '../components/ObjectTypePicker/resources/ArchiveFileTypeResource';
import {audioFileTypeResource} from '../components/ObjectTypePicker/resources/AudioFileTypeResource';
import {documentFileTypeResource} from '../components/ObjectTypePicker/resources/DocumentFileTypeResource';
import {imageFileTypeResource} from '../components/ObjectTypePicker/resources/ImageFileTypeResource';
import {presentationFileTypeResource} from '../components/ObjectTypePicker/resources/PresentationFileTypeResource';
import {sheetFileTypeResource} from '../components/ObjectTypePicker/resources/SheetFileTypeResource';
import {videoFileTypeResource} from '../components/ObjectTypePicker/resources/VideoFileTypeResource';
import {otherFileTypeResource} from '../components/ObjectTypePicker/resources/OtherFileTypeResource';
import {getEmptySearchFilterPredefined} from './DtoUtils';
import {objectTypeOptionResource} from '../components/ObjectTypePicker/resources/ObjectTypeResource';
import {TYPE_ALL} from '../components/ObjectTypePicker/resources/FileTypeResource';
import {SortOrder} from '../models/SortOrder';
import {BreadcrumbPaths} from '../components/Breadcrumb/Breadcrumb';
import {convertToStringArray, isNullOrEmpty} from './HelperUtils';
import {SEARCH_TERM_MINIMAL_CHARACTERS_LENGTH} from '../init/constants';

export const isInResource = (entity: string, resource: { value: string }[]): boolean => {
    if (isNullOrEmpty(entity)) {
        return false;
    }

    return resource.some(option => option.value === entity.trim());
};

export const isInAnyResource = (entity: string, resources: { value: string }[][]): boolean => {
    if (isNullOrEmpty(entity)) {
        return false;
    }

    return resources.some(resource => resource.some(option => option.value === entity.trim()));
};

export const fileTypeResources = [
    archiveFileTypeResource,
    audioFileTypeResource,
    documentFileTypeResource,
    imageFileTypeResource,
    presentationFileTypeResource,
    sheetFileTypeResource,
    videoFileTypeResource,
    otherFileTypeResource
];

export const createSearchFilterPredefined = (searchParam: string | null, fileTypes: string[] | null, objectType: string): SearchFilterPredefined => {
    let searchFilterPredefined = getEmptySearchFilterPredefined();
    if ((searchParam !== undefined) && searchParam && (!isNullOrEmpty(searchParam.trim()))) {
        searchFilterPredefined.searchParam = searchParam.trim()
    }

    if ((objectType !== undefined) && objectType && isInResource(objectType, objectTypeOptionResource)) {
        searchFilterPredefined.objectType = objectType.toLowerCase();
    }

    if ((fileTypes !== undefined) && fileTypes && (fileTypes.length > 0)) {
        searchFilterPredefined.fileTypes = convertToStringArray(fileTypes).filter(entity => isInAnyResource(entity, fileTypeResources));
    }

    return searchFilterPredefined;
};

export const getSearchFilterPredefined = (predefinedFilters: SearchFilterPredefined): SearchFilterPredefined => {
    return createSearchFilterPredefined(predefinedFilters.searchParam, predefinedFilters.fileTypes, predefinedFilters.objectType);
};

export const isPredefinedFilterApplicable = (predefinedFilters: SearchFilterPredefined): boolean => {
    return ((predefinedFilters.searchParam && (!isNullOrEmpty(predefinedFilters.searchParam)))
        || (predefinedFilters.fileTypes && (predefinedFilters.fileTypes.length > 0))
        || ((!isNullOrEmpty(predefinedFilters.objectType)) && (predefinedFilters.objectType.toLowerCase() !== TYPE_ALL)));
}

export const isSearchFilterApplied = (searchTerm: string | null, isRecentlyAdded: boolean, isFavorite: boolean, isPublic: boolean, sortOrder: string, objectType: string, fileTypes: string[] | null): boolean => {
    return ((!isNullOrEmpty(searchTerm))
        || (isRecentlyAdded)
        || (isFavorite)
        || (isPublic)
        || (sortOrder && (sortOrder === SortOrder.DESC))
        || (objectType && (objectType.toLowerCase() !== TYPE_ALL))
        || (fileTypes && (fileTypes.length > 0))) as boolean;
};

export const getBreadcrumbState = (searchTerm: string | null, isRecentlyAdded: boolean, isFavorite: boolean, isPublic: boolean, sortOrder: string, objectType: string, fileTypes: string[] | null): BreadcrumbPaths => {
    if (isSearchFilterApplied(searchTerm, isRecentlyAdded, isFavorite, isPublic, sortOrder, objectType, fileTypes)) {
        return BreadcrumbPaths.FILTERED;
    }

    return BreadcrumbPaths.HOME;
};

export const isValidSearchTerm = (searchTermInputValue: string | null | undefined): boolean => {
    let searchTermValue = searchTermInputValue ?? '';
    if ((isNullOrEmpty(searchTermValue)) || ((searchTermValue.trim()).length >= SEARCH_TERM_MINIMAL_CHARACTERS_LENGTH)) {
        return true;
    }

    return false;
};